<template>
  <v-layout>
    <div
      class="custom-content-container pt-0 w-100"
      cols="12"
      :md="12"
      :sm="12"
    >
      <v-layout class="d-block iv-custom-field">
        <v-container fluid class="pt-0">
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll"
            style="max-height: calc(100vh - 205px); position: relative"
          >
            <v-container fluid class="py-0 px-1">
              <v-row>
                <v-col cols="12" md="12" class="pt-0">
                  <!-- Lead Details Card -->
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title class="headline grey lighten-4 py-2">
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue mb-0"
                      >
                        Lead Details
                      </h3>
                    </v-card-title>

                    <v-card-text class="p-6 font-size-16">
                      <v-row dense>
                        <!-- Lead Type as Radio Buttons (Hidden) -->
                        <v-col cols="12" md="12" v-show="false">
                          <label class="font-weight-600">Lead Type</label>
                          <v-radio-group
                            v-model="detail.lead_type"
                            row
                            hide-details
                            class="mt-0"
                          >
                            <v-radio
                              label="New Lead"
                              value="new"
                              color="blue"
                            ></v-radio>
                            <v-radio
                              label="Follow Up Lead"
                              value="follow_up"
                              color="green"
                            ></v-radio>
                            <v-radio
                              label="Converted Lead"
                              value="converted"
                              color="orange"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>

                        <!-- Title -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="required font-weight-600">Title</label>
                          <TextField
                            dense
                            filled
                            color="cyan"
                            placeholder="Title"
                            solo
                            counter="50"
                            :maxlength="50"
                            flat
                            class="width-100"
                            :rules="[
                              validateRules.required(
                                detail.lead_name,
                                'Lead Name'
                              ),
                              validateRules.maxLength(
                                detail.lead_name,
                                'Lead Name',
                                50
                              ),
                              validateRules.minLength(
                                detail.lead_name,
                                'Lead Name',
                                2
                              ),
                              validateRules.validPersonName(
                                detail.lead_name,
                                'Lead Name'
                              ),
                            ]"
                            v-model.trim="detail.lead_name"
                          ></TextField>
                        </v-col>

                        <!-- Status (Hidden) -->
                        <v-col cols="12" md="6" v-show="false">
                          <label class="font-weight-600">Status</label>
                          <v-autocomplete
                            hide-details
                            v-model.trim="detail.status"
                            :items="statusList"
                            dense
                            flat
                            filled
                            placeholder="Status"
                            item-color="cyan"
                            color="cyan"
                            solo
                            item-value="value"
                            item-text="text"
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title
                                  >No Status(s) Found.</v-list-item-title
                                >
                              </v-list-item>
                            </template>
                            <template v-slot:selection="{ item }">
                              <v-list-item-action class="mx-0 my-0 py-0">
                                <v-chip
                                  style="height: 10px; width: 10px; padding: 0"
                                  :color="item.color"
                                ></v-chip>
                              </v-list-item-action>
                              <v-list-item-content class="py-0">
                                <v-list-item-title
                                  class="text-capitalize font-weight-500 font-size-16"
                                >
                                  {{ item.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-action class="mr-0">
                                <v-chip
                                  style="height: 16px; width: 16px; padding: 0"
                                  :color="item.color"
                                ></v-chip>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="text-capitalize font-weight-500 font-size-16"
                                >
                                  {{ item.text }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </v-col>

                        <!-- Source -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="required font-weight-600">Source</label>
                          <v-autocomplete
                            hide-details
                            v-model.trim="detail.source"
                            :items="sourceList"
                            :rules="[
                              validateRules.required(detail.source, 'source'),
                            ]"
                            dense
                            flat
                            filled
                            placeholder="Source"
                            item-color="cyan"
                            color="cyan"
                            solo
                            item-value="value"
                            item-text="text"
                          >
                            <template v-slot:item="{ item }">
                              <div class="d-flex align-center">
                                <v-icon small color="cyan" class="mr-2">
                                  {{ item.icon }}
                                </v-icon>
                                <span>{{ item.text }}</span>
                              </div>
                            </template>
                            <template v-slot:selection="{ item }">
                              <div class="d-flex align-center">
                                <v-icon small color="cyan" class="mr-1">
                                  {{ item.icon }}
                                </v-icon>
                                <span>{{ item.text }}</span>
                              </div>
                            </template>

                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title
                                  >No Source(s) Found.</v-list-item-title
                                >
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>

                        <!-- Opportunity (Hidden) -->
                        <v-col cols="12" md="6" v-show="false">
                          <label class="font-weight-600">Opportunity</label>
                          <v-radio-group
                            v-model="detail.opportunity"
                            row
                            hide-details
                          >
                            <v-radio
                              label="High Chance"
                              value="High Chance"
                            ></v-radio>
                            <v-radio label="50 50" value="50 50"></v-radio>
                            <v-radio
                              label="Low Chance"
                              value="Low Chance"
                            ></v-radio>
                            <v-radio label="None" value="None"></v-radio>
                          </v-radio-group>
                        </v-col>

                        <!-- Assign To -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="required font-weight-600"
                            >Assign To</label
                          >
                          <v-autocomplete
                            dense
                            color="cyan"
                            filled
                            :items="userList"
                            :disabled="pageLoading"
                            :loading="pageLoading"
                            v-model.trim="detail.assign_to"
                            :rules="[
                              validateRules.required(
                                detail.assign_to,
                                'Assign To'
                              ),
                            ]"
                            placeholder="Assign To"
                            solo
                            flat
                            item-color="cyan"
                            item-text="display_name"
                            item-value="id"
                            hide-details
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    >No User Found.</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>

                        <!-- Lead Date -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="font-weight-600">Lead Date</label>
                          <DatePicker
                            solo
                            flat
                            dense
                            filled
                            :mandatory="false"
                            :nullable="true"
                            placeholder="Lead Date"
                            v-model="detail.lead_date"
                          ></DatePicker>
                        </v-col>

                        <!-- Amount (Hidden) -->
                        <v-col cols="12" md="6" v-show="false">
                          <label class="font-weight-600">Amount</label>
                          <v-text-field
                            dense
                            flat
                            filled
                            solo
                            v-model="detail.amount"
                            placeholder="0.00"
                            type="number"
                            hide-details
                            @keypress="limitDecimal"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- Customer Details Card -->
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title class="headline grey lighten-4 py-2">
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue mb-0"
                      >
                        Customer Details
                      </h3>
                    </v-card-title>

                    <v-card-text class="p-6 font-size-16">
                      <v-row dense>
                        <!-- Customer Type Section -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="font-weight-600">Customer Type</label>
                          <v-radio-group
                            v-model="detail.company_type"
                            row
                            hide-details
                            class="mt-0"
                            :disabled="isUpdateMode"
                          >
                            <v-radio
                              style="margin-right: -2px"
                              value="company"
                              color="blue"
                            ></v-radio>
                            <v-chip
                              label
                              :color="
                                detail.company_type === 'company'
                                  ? 'blue'
                                  : 'grey'
                              "
                              :outlined="detail.company_type !== 'company'"
                              class="text-white p-3 mr-5 cursor-pointer"
                              small
                              @click="detail.company_type = 'company'"
                              >Company</v-chip
                            >
                            <v-radio
                              value="personal"
                              color="red"
                              style="margin-right: -2px"
                            ></v-radio>
                            <v-chip
                              label
                              :color="
                                detail.company_type === 'personal'
                                  ? 'red'
                                  : 'grey'
                              "
                              :outlined="detail.company_type !== 'personal'"
                              class="text-white p-3 cursor-pointer"
                              small
                              @click="detail.company_type = 'personal'"
                              >Individual</v-chip
                            >
                          </v-radio-group>
                        </v-col>

                        <!-- Company Name -->
                        <v-col
                          cols="12"
                          md="6"
                          v-if="showCompanyName"
                          class="pb-2"
                        >
                          <label class="font-weight-600">Company Name</label>
                          <v-combobox
                            ref="companyNameField"
                            dense
                            filled
                            color="cyan"
                            placeholder="Company Name"
                            solo
                            flat
                            class="width-100"
                            v-model="selectedCompany"
                            :items="companySearchResults"
                            item-text="company_name"
                            item-value="id"
                            return-object
                            :no-filter="true"
                            :loading="companySearchLoading"
                            hide-no-data
                            @input="validateCompanyNameField"
                            @change="validateCompanyNameField"
                            @blur="validateCompanyNameField"
                            @update:search-input="onCompanySearchInput"
                            :rules="[
                              validateRules.required(
                                detail.company_name,
                                'Company Name'
                              ),
                              validateRules.minLength(
                                detail.company_name,
                                'Company Name',
                                2
                              ),
                              validateRules.maxLength(
                                detail.company_name,
                                'Company Name',
                                100
                              ),
                              validateRules.validNotOnlyNumbersOrSymbols(
                                detail.company_name,
                                'Company Name'
                              )
                            ]"
                            :maxlength="100"
                          >
                            <template v-slot:no-data>
                              <v-list-item
                                v-if="
                                  companySearch && companySearch.length >= 2
                                "
                              >
                                <v-list-item-content>
                                  <v-list-item-title
                                    >No matching company
                                    found.</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-combobox>
                        </v-col>

                        <!-- Phone Number -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="font-weight-600">Phone Number</label>
                          <PhoneTextField
                            :key="phoneFieldKey"
                            v-model="detail.phone_number"
                            v-on:blur="isFocusedN = false"
                            v-on:focus="isFocusedN = true"
                          >
                          </PhoneTextField>
                        </v-col>

                        <!-- Email -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="required font-weight-600">Email</label>
                          <v-text-field
                            dense
                            filled
                            color="cyan"
                            placeholder="Email"
                            @blur="onEmailBlur"
                            solo
                            flat
                            class="width-100"
                            v-model.trim="detail.email"
                            type="email"
                            hide-details
                            :validate-on-blur="false"
                            :rules="[
                              validateRules.required(detail.email, 'email'),
                              validateRules.validEmail(detail.email, 'email'),
                              validateRules.maxLength(detail.email, 'email', 100)
                            ]"
                            :maxlength="100"
                          />
                        </v-col>

                        <!-- Website -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="font-weight-600">Website</label>
                          <v-text-field
                            dense
                            filled
                            color="cyan"
                            placeholder="Website"
                            solo
                            flat
                            class="width-100"
                            v-model.trim="detail.website"
                            hide-details
                            :rules="[
                              validateRules.minLength(
                                detail.website,
                                 'website',
                                  3
                                ),
                              validateRules.maxLength(
                                detail.website,
                                'Website',
                                50
                              ),
                              validateRules.validateWebsite(
                                detail.website,
                                'website'
                              ),
                            ]"
                            :maxlength="50"
                          ></v-text-field>
                        </v-col>

                        <!-- Opportunity -->
                        <v-col cols="12" md="6" class="pb-2">
                          <label class="font-weight-600">Opportunity</label>
                          <v-radio-group
                            v-model="detail.opportunity"
                            row
                            hide-details
                          >
                            <v-radio
                              label="High Chance"
                              value="High Chance"
                              color="cyan"
                            ></v-radio>
                            <v-radio
                              label="50 50"
                              value="50 50"
                              color="cyan"
                            ></v-radio>
                            <v-radio
                              label="Low Chance"
                              value="Low Chance"
                              color="cyan"
                            ></v-radio>
                            <v-radio
                              label="None"
                              value="None"
                              color="cyan"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>

                        <!-- Product Type (Hidden) -->
                        <v-col cols="12" md="6" v-show="false">
                          <label class="font-weight-600">Product Type</label>
                          <v-autocomplete
                            hide-details
                            v-model.trim="detail.product_type"
                            :items="productTypeList"
                            dense
                            flat
                            filled
                            placeholder="Product Type"
                            item-color="cyan"
                            append-outer-icon="mdi-cog"
                            v-on:click:append-outer="openProductTypeDialog"
                            color="cyan"
                            solo
                            item-value="value"
                            item-text="text"
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title
                                  >No Product Type(s) Found.</v-list-item-title
                                >
                              </v-list-item>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- Address Information Card -->
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title
                      class="headline grey lighten-4 cursor-pointer"
                      @click="show_address = !show_address"
                    >
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue mb-0"
                      >
                        <v-icon>{{
                          !show_address ? "mdi-chevron-down" : "mdi-chevron-up"
                        }}</v-icon>
                        Address Information
                      </h3>
                    </v-card-title>
                    <v-expand-transition>
                      <v-card-text
                        class="p-6 font-size-16"
                        v-show="show_address"
                      >
                        <v-row dense>
                          <!-- Search Address -->
                          <v-col cols="12" md="6" class="pb-2">
                            <label class="font-weight-600"
                              >Search Address</label
                            >
                            <SearchAddress
                              min-height="32"
                              variant="outlined"
                              density="compact"
                              hide-details
                              :country="detail.country"
                              :country-code="country_code"
                              @update:address="(data) => setAddress(data)"
                              placeholder="Search Address"
                            />
                          </v-col>

                          <!-- Country -->
                          <v-col cols="12" md="6" class="pb-2">
                            <label class="font-weight-600">Country</label>
                            <v-autocomplete
                              hide-details
                              v-model.trim="detail.country"
                              :items="countryList"
                              dense
                              flat
                              filled
                              placeholder="Country"
                              item-color="cyan"
                              color="cyan"
                              solo
                              item-value="value"
                              item-text="text"
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-title
                                    >No Country(s) Found.</v-list-item-title
                                  >
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>

                          <!-- Postal Code -->
                          <v-col cols="12" md="6" class="pb-2">
                            <label class="font-weight-600">Postal Code</label>
                            <v-text-field
                              dense
                              filled
                              color="cyan"
                              placeholder="Postal Code"
                              type="text"
                              inputmode="numeric"
                              @keypress="restrictNonNumericInput"
                              @paste="handlePostalPaste"
                              solo
                              flat
                              class="width-100"
                              v-model.trim="detail.postal_code"
                              hide-details
                              :rules="[
                                validateRules.minLength(
                                  detail.postal_code,
                                  'Postal Code',
                                  2
                                ),
                                validateRules.maxLength(
                                  detail.postal_code,
                                  'Postal Code',
                                  6
                                ),
                              ]"
                              :maxlength="6"
                            ></v-text-field>
                          </v-col>

                          <!-- Address Line 1 -->
                          <v-col cols="12" md="6" class="pb-2">
                            <label class="font-weight-600"
                              >Address Line 1</label
                            >
                            <v-text-field
                              dense
                              filled
                              color="cyan"
                              placeholder="Address Line 1"
                              solo
                              flat
                              class="width-100"
                              v-model.trim="detail.address_line_1"
                              hide-details
                              :rules="[
                                validateRules.maxLength(
                                  detail.address_line_1,
                                  'Address Line 1',
                                  100
                                ),
                              ]"
                              :maxlength="100"
                            ></v-text-field>
                          </v-col>

                          <!-- Address Line 2 -->
                          <v-col cols="12" md="6" class="pb-2">
                            <label class="font-weight-600"
                              >Address Line 2</label
                            >
                            <v-text-field
                              dense
                              filled
                              color="cyan"
                              placeholder="Address Line 2"
                              solo
                              flat
                              class="width-100"
                              v-model.trim="detail.address_line_2"
                              hide-details
                              :rules="[
                                validateRules.maxLength(
                                  detail.address_line_2,
                                  'Address Line 2',
                                  100
                                ),
                              ]"
                              :maxlength="100"
                            ></v-text-field>
                          </v-col>

                          <!-- Unit Number -->
                          <v-col cols="12" md="6" class="pb-2">
                            <label class="font-weight-600">Unit Number</label>
                            <v-text-field
                              dense
                              filled
                              color="cyan"
                              placeholder="Unit Number"
                              solo
                              flat
                              class="width-100"
                              v-model.trim="detail.unit_no"
                              hide-details
                              :rules="[
                                validateRules.maxLength(
                                  detail.unit_no,
                                  'Unit Number',
                                  100
                                ),
                              ]"
                              :maxlength="100"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-expand-transition>
                  </v-card>

                  <!-- Description Card -->
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title
                      class="headline grey lighten-4 cursor-pointer"
                      @click="show_description = !show_description"
                    >
                      <h3
                        class="font-weight-700 custom-headline color-custom-blue mb-0"
                      >
                        <v-icon>{{
                          !show_description
                            ? "mdi-chevron-down"
                            : "mdi-chevron-up"
                        }}</v-icon>
                        Description
                      </h3>
                    </v-card-title>
                    <v-expand-transition>
                      <v-card-text
                        class="p-6 font-size-16"
                        v-show="show_description"
                      >
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              v-model="detail.internal_remark"
                              auto-grow
                              dense
                              filled
                              color="cyan"
                              placeholder="Description"
                              solo
                              flat
                              row-height="15"
                              v-on:keypress="(e) => manageRemarkLimit(e)"
                              v-on:paste="(e) => onRemarkPaste(e)"
                            ></v-textarea>
                            <div class="text-right text-caption mt-1">
                              {{
                                detail.internal_remark
                                  ? detail.internal_remark.length
                                  : 0
                              }}/200
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-expand-transition>
                  </v-card>

                  <!-- Email Reply Card (Hidden) -->
                  <v-card class="rounded pa-4 mt-4" v-show="false">
                    <div class="text-h6">Email Reply (Inquiry Message)</div>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="detail.email_reply"
                          auto-grow
                          dense
                          filled
                          color="cyan"
                          placeholder="Email Reply(Inquiry Message)"
                          solo
                          flat
                          row-height="15"
                          v-on:keypress="(e) => manageReplyLimit(e)"
                          v-on:paste="(e) => onReplyPaste(e)"
                        ></v-textarea>
                        <div class="text-right text-caption mt-1">
                          {{
                            detail.email_reply ? detail.email_reply.length : 0
                          }}/200
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>

                  <!-- Attachments Section -->
                  <div class="mt-4">
                    <CollapsibleDocumnetList
                      :typeId="detail.id"
                      :extensive="false"
                      v-model="detail.attachments"
                      :document-type="docType"
                    >
                    </CollapsibleDocumnetList>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </perfect-scrollbar>
        </v-container>
      </v-layout>
    </div>

    <!-- Dialogs -->
    <ManageProductType
      :d-dialog="manageProductType"
      :product_types="productTypeList"
      v-on:close-dialog="manageProductType = false"
      v-on:get-product-types="getOptions"
    ></ManageProductType>

    <ManagePosition
      :d-dialog="managePosition"
      :e_positions="positionList"
      v-on:close-dialog="managePosition = false"
      v-on:get-positions="getOptions"
    ></ManagePosition>

    <Dialog :common-dialog="companyRouteDialog">
      <template v-slot:title>Create Opportunity for Customer</template>
      <template v-slot:body>
        <p class="font-size-19 font-weight-600 mx-2 my-0">
          The selected company
          <span class="font-weight-700">{{
            selectedCompanyCustomerRoute?.company_name
          }}</span>
          is already registered as a customer.
        </p>
        <p class="font-size-16 mx-2 mt-2">
          Do you want to create a new opportunity for this customer now?
        </p>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          class="mx-2 custom-grey-border custom-bold-button"
          :disabled="false"
          @click="goBack"
        >
          Cancel
        </v-btn>
        <v-btn
          depressed
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          @click="navigateToOpportunityCreate"
        >
          Create Opportunity
        </v-btn>
      </template>
    </Dialog>
  </v-layout>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
// import DocumnetList from "@/view/pages/DocumnetList";
import CollapsibleDocumnetList from "@/view/pages/CollapsibleDocumnetList";
import ManageProductType from "@/view/pages/partials/Manage-Product-Type.vue";
import ManagePosition from "@/view/pages/partials/Manage-Position.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CustomerMixin from "@/core/plugins/customer-mixin";
import { GET, QUERY } from "@/core/services/store/request.module";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import { SET_ACTIVE_FIELD_DATA } from "@/core/services/store/custom.fields.module.js";
import DatePicker from "@/view/components/DatePicker.vue";
import SearchAddress from "@/view/components/Search-Address";
import Dialog from "@/view/pages/partials/Dialog.vue";

export default {
  name: "contact-details",
  title: "Customer",
  mixins: [CommonMixin, ValidationMixin, CustomerMixin, FileManagerMixin],
  props: {
    lead: {
      type: Object,
      default: function () {
        return {};
      },
    },
    detail: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupList: [],
      docType: 20,
      pageLoading: false,
      isPrefilling: false,
      selectedCompany: null,
      manageProductType: false,
      managePosition: false,
      phoneFieldKey: 0,
      entityList: [],
      proposal: 0,
      timeoutLimit: 500,
      timeout: null,
      autocompleteList: new Array(),
      autocompleteLoading: false,
      isFocused: false,
      isFocusedU: false,
      isFocusedN: false,
      isFocusedD: false,
      custom_field_module_id: null,
      companyRouteDialog: false,
      selectedCompanyCustomerRoute: null,
      companyRouteDialogEnabled: false,
      companySearch: "",
      companySearchResults: [],
      companySearchLoading: false,
      debouncedCompanySearch: null,
      productTypeList: [],
      userList: [],
      positionList: [],
      imageLoading: false,
      show_address: false,
      show_description: false,
      show_attachments: true,
      country_code: "sg",
      emailDetails: [
        {
          title: "main",
          value: null,
          type: 1,
          id: null,
        },
      ],
      contactDetails: [
        {
          title: "main",
          value: null,
          type: 2,
          id: null,
        },
        {
          title: "fax",
          value: null,
          type: 2,
          id: null,
        },
      ],
      sourceList: [
        {
          text: "Web Enquiry",
          value: "Web Enquiry",
          icon: "mdi-web",
        },
        {
          text: "Web Chat",
          value: "Web Chat",
          icon: "mdi-chat",
        },
        {
          text: "Email Marketer",
          value: "Email Marketer",
          icon: "mdi-email",
        },
        {
          text: "Tele Call",
          value: "Tele Call",
          icon: "mdi-phone",
        },
        {
          text: "Google Adwords",
          value: "Google Adwords",
          icon: "mdi-google",
        },
        {
          text: "Fsm/Ams",
          value: "Fsm/Ams",
          icon: "mdi-cog",
        },
        {
          text: "Facebook",
          value: "Facebook",
          icon: "mdi-facebook",
        },
        {
          text: "Referral",
          value: "Referral",
          icon: "mdi-account-group",
        },
        {
          text: "Intern",
          value: "Intern",
          icon: "mdi-school",
        },
        {
          text: "Canvassing Team",
          value: "Canvassing Team",
          icon: "mdi-account-multiple",
        },
        {
          text: "None",
          value: "None",
          icon: "mdi-minus-circle-outline",
        },
      ],
      countryList: [
        {
          text: "Singapore",
          value: "singapore",
          country_code: "sg",
        },
        {
          text: "Malaysia",
          value: "malaysia",
          country_code: "my",
        },
        {
          text: "Myanmar",
          value: "myanmar",
          country_code: "mm",
        },
        {
          text: "India",
          value: "india",
          country_code: "in",
        },
        {
          text: "China",
          value: "china",
          country_code: "cn",
        },
        {
          text: "Australia",
          value: "australia",
          country_code: "at",
        },
        {
          text: "American",
          value: "american",
          country_code: "as",
        },
        {
          text: "UK",
          value: "uk",
          country_code: "gb",
        },
        {
          text: "Canada",
          value: "canada",
          country_code: "ca",
        },
      ],
      statusList: [
        {
          text: "Draft",
          value: "Draft",
          color: "cyan",
        },
        {
          text: "Not Contacted",
          value: "Not Contacted",
          color: "grey",
        },
        {
          text: "Follow Up",
          value: "Follow Up",
          color: "yellow",
        },
        {
          text: "Meeting",
          value: "Meeting",
          color: "blue",
        },
        {
          text: "Converted to Customer",
          value: "Converted to Customer",
          color: "orange",
        },
        {
          text: "Accepted",
          value: "Accepted",
          color: "green",
        },
        {
          text: "Rejected",
          value: "Rejected",
          color: "red",
        },
      ],
      fieldDescriptions: [
        {
          field: "product_type",
          title: "Product Type",
          description:
            "Select if this item is a physical good or a service you're offering.",
          footer: "Note",
          footer_content:
            "Once you include this items in a transaction, you cannot change its type.",
        },
      ],
    };
  },
  watch: {
    companyList(newList) {
      if (!newList || newList.length === 0) return;
      // Prefill only if we don't already have a selectedCompany and detail has company_name
      if (!this.selectedCompany && this.detail && this.detail.company_name) {
        this.setSelectedCompany();
      }
    },

    selectedCompany(newVal) {
      if (newVal === null || newVal === undefined) {
        this.detail.company_name = null;
        this.validateCompanyNameField();
        return;
      }
      if (typeof newVal === "object") {
        this.detail.company_name = newVal.company_name;
        if (newVal.id) {
          if (this.companyRouteDialogEnabled) {
            this.selectedCompanyCustomerRoute = newVal;
            this.companyRouteDialog = true;
          }
          this.getFullCompanyDetails(newVal.id);
        }
      } else if (typeof newVal === "string") {
        this.detail.company_name = newVal;
      }
    },
    detail: {
      handler(param) {
        this.$emit("update:detail", { ...param });
      },
      deep: true,
    },
    "detail.lead_type"(newValue) {
      console.log("Lead type changed to:", newValue);
    },
    "detail.company_type"(newValue) {
      if (newValue !== "company") {
        this.detail.company_name = null;
        this.selectedCompany = null;
      } else {
        this.setSelectedCompany();
      }
    },
    "detail.email"(newValue) {
      if (this.detail.company_type === "personal") {
        if (this.isPrefilling) {
          this.debouncedEmailCheck(newValue);
        }
      }
    },
    "detail.country"(newValue) {
      this.setCountryCode(newValue);
    },
  },
  methods: {
    onEmailBlur() {
      if (this.detail.email && this.detail.company_type === "personal") {
        this.searchIndividualByEmail(this.detail.email);
      }
    },
    navigateToOpportunityCreate() {
      if (!this.selectedCompanyCustomerRoute) {
        this.companyRouteDialog = false;
        return;
      }

      const customerId = Number(this.selectedCompanyCustomerRoute.id || 0);
      const personId = Number(
        this.selectedCompanyCustomerRoute.default_person?.id ||
          this.selectedCompanyCustomerRoute.person_id ||
          0
      );

      this.companyRouteDialog = false;
      this.$router.push({
        name: "admin.opportunity.create",
        query: {
          type: "customer",
          customer: customerId,
          person: personId || undefined,
          return_to: "lead-list",
        },
      });
    },
    debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },

    limitDecimal(event) {
      const value = event.target.value;
      const key = event.key;

      if (
        ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(key)
      )
        return;

      if (!/[0-9.]/.test(key)) {
        event.preventDefault();
        return;
      }

      if (key === "." && value.includes(".")) {
        event.preventDefault();
        return;
      }

      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        const decimals = value.substring(decimalIndex + 1);
        if (
          decimals.length >= 2 &&
          event.target.selectionStart > decimalIndex
        ) {
          event.preventDefault();
        }
      }
    },

    restrictNonNumericInput(event) {
      if (
        event.ctrlKey ||
        event.metaKey ||
        [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Home",
          "End",
          "Tab",
        ].includes(event.key)
      ) {
        return;
      }

      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },

    handlePostalPaste(event) {
      const digitsOnly = event.clipboardData
        .getData("text")
        .replace(/\D/g, "");
      const input = event.target;
      const current = this.detail.postal_code || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const remainingLength = current.length - (end - start);
      const availableLength = Math.max(6 - remainingLength, 0);
      const pastedDigits = digitsOnly.slice(0, availableLength);

      event.preventDefault();

      if (!pastedDigits) {
        return;
      }

      this.detail.postal_code =
        current.slice(0, start) + pastedDigits + current.slice(end);
    },

    onRemarkPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.detail.internal_remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.detail.internal_remark = trimValue;
        e.preventDefault();
      }
    },

    manageRemarkLimit(e) {
      if (
        this.detail.internal_remark &&
        this.detail.internal_remark.length > 199
      ) {
        e.preventDefault();
      }
    },

    onReplyPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.detail.email_reply;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.detail.email_reply = trimValue;
        e.preventDefault();
      }
    },

    manageReplyLimit(e) {
      if (this.detail.email_reply && this.detail.email_reply.length > 199) {
        e.preventDefault();
      }
    },

    openProductTypeDialog() {
      this.manageProductType = true;
      this.getOptions();
    },

    openPositionDialog() {
      this.managePosition = true;
      this.getOptions();
    },

    getOptions() {
      this.pageLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "lead/options",
        })
        .then(({ data }) => {
          if (data.product_types) {
            this.productTypeList = data.product_types;
          }

          if (data.users) {
            this.userList = data.users;
          }

          if (data.positions) {
            this.positionList = data.positions;
          }
        })
        .catch((error) => {
          this.logError(error);
          this.goBack();
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },

    clearAddress() {
      const _this = this;
      _this.detail.postal_code = null;
      _this.detail.address_line_1 = null;
      _this.detail.address_line_2 = null;
      _this.detail.unit_no = null;
    },

    setAddress(e) {
      this.detail.postal_code = e.postal_code;
      this.detail.address_line_1 = e.address1;
      this.detail.address_line_2 = e.address2;
    },

    setCountryCode(data) {
      let code = "";
      code = this.lodash.find(this.countryList, function (row) {
        if (row.value == data) {
          return row.country_code;
        } else {
          return false;
        }
      });

      this.country_code = code ? code.country_code : "sg";
    },

    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.detail.customer_remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.detail.customer_remark = trimValue;
        e.preventDefault();
      }
    },

    updateDetails() {
      const _this = this;
      _this.detail.details = [];
      for (let i = 0; i < _this.emailDetails.length; i++) {
        if (_this.emailDetails[i]) {
          delete _this.emailDetails[i].default;
          _this.detail.details.push(_this.emailDetails[i]);
        }
      }
      for (let z = 0; z < _this.contactDetails.length; z++) {
        if (_this.contactDetails[z]) {
          delete _this.contactDetails[z].default;
          _this.detail.details.push(_this.contactDetails[z]);
        }
      }
    },

    getGroupList() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "customer/group-list",
        })
        .then(({ data }) => {
          _this.groupList = data.group_list;
        })
        .catch((error) => {
          this.logError(error);
        });
    },

    validateCompanyNameField() {
      this.$nextTick(() => {
        const field = this.$refs.companyNameField;
        if (field && typeof field.validate === "function") {
          field.validate();
        }
      });
    },

    // onCompanySearchInput(searchValue) {
    //   this.companySearch = searchValue;
    //   if (!searchValue || searchValue.length < 2) {
    //     this.companySearchResults = [];
    //     return;
    //   }
    //   if (this.debouncedCompanySearch) {
    //     this.debouncedCompanySearch(searchValue);
    //   }
    // },
    onCompanySearchInput(searchValue) {
      this.companySearch = searchValue;

      this.detail.company_name = searchValue;

      this.validateCompanyNameField();

      if (!searchValue || searchValue.length < 2) {
        this.companySearchResults = [];
        return;
      }

      this.debouncedCompanySearch(searchValue);
    },

    searchCompanyByName(searchValue) {
      if (!searchValue || searchValue.length < 2) {
        this.companySearchResults = [];
        return;
      }

      this.companySearchLoading = true;
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "search-company-for-leads",
          data: {
            type: "customers",
            name: "company_name",
            value: searchValue,
            module: "lead",
          },
        })
        .then((data) => {
          const results = Array.isArray(data) ? data : data?.data?.rows || [];
          _this.companySearchResults = results;
        })
        .catch((error) => {
          console.error("Company search error:", error);
          _this.companySearchResults = [];
          _this.logError(error);
        })
        .finally(() => {
          _this.companySearchLoading = false;
        });
    },

    async getFullCompanyDetails(companyId) {
      if (!companyId) return;

      try {
        const _this = this;

        // 1️⃣ Fetch company + contact person details
        const response = await _this.$store.dispatch(QUERY, {
          url: `customer-with-relation/${companyId}`,
          data: { contact_person: null, property: null },
        });

        const customer = (response.data || {}).customer || {};
        const website = customer.website || "";

        // 2️⃣ Fetch full company list (to get default_person)
        const companyListResponse = await _this.$store.dispatch(QUERY, {
          url: "customer",
          data: {
            entity: 1,
            status: "all",
            all: true,
            filter_type: "company",
          },
        });

        const companies = companyListResponse.data.rows || [];
        _this.$set(_this.options, "companies", companies);

        const selectedCompany = companies.find((r) => r.id == companyId);
        const defaultCP = selectedCompany?.default_person || {};

        // Safe values
        const phone = defaultCP.primary_phone || "";
        const email = defaultCP.primary_email || "";

        // 3️⃣ Fetch attachments

        let leadAttachments = [];

        if (_this.detail.id) {
          const attachmentsResponse = await _this.$store.dispatch(GET, {
            url: `documents/20/${_this.detail.id}`,
          });

          if (attachmentsResponse.data) {
            leadAttachments = attachmentsResponse.data.filter(
              (doc) => Number(doc.type) === 20
            );
          }
        }

        // 4️⃣ Update ONLY the fields — do NOT replace entire detail object
        _this.detail.website = website;
        _this.detail.phone_number = phone;
        _this.detail.email = email;
        _this.detail.attachments = leadAttachments;

        // 5️⃣ Force phone component refresh
        _this.$nextTick(() => {
          _this.phoneFieldKey++;
        });
      } catch (err) {
        console.error(err);
        this.logError(err);
      }
    },

    setSelectedCompany() {
      if (!this.detail || this.detail.company_type !== "company") {
        this.selectedCompany = null;
        return;
      }

      const name = this.detail.company_name;
      if (!name) {
        this.selectedCompany = null;
        return;
      }

      // if companyList has an exact match, select that object (preferred)
      const found = (this.companyList || []).find(
        (c) =>
          c &&
          (c.company_name === name ||
            String(c.id) === String(this.detail.company_id))
      );

      if (found) {
        this.selectedCompany = found;
      } else {
        // fallback: create a virtual object so combobox displays text
        this.selectedCompany = {
          id: this.detail.company_id || null,
          company_name: name,
        };
      }
    },

    searchIndividualByEmail(searchValue) {
      if (!searchValue || searchValue.length < 2) return;

      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "individual-by-email",
          data: {
            email: searchValue,
          },
        })
        .then((response) => {
          const data = response.data;
          if (!data) return;
          console.log("Individual details:", data);

          const customer = data.customer || {};
          const billingCP = data.billing_contact_person || {};

          // 📌 Prefill Phone
          if (billingCP.primary_phone) {
            _this.detail.phone_number = billingCP.primary_phone;
          }

          // 📌 Prefill Email (already selected, but ensure)
          if (billingCP.primary_email && !_this.detail.email) {
            // mark as programmatic prefill so watcher triggers debounced search if needed
            _this.isPrefilling = true;
            _this.detail.email = billingCP.primary_email;
          }

          // 📌 Prefill Website
          if (customer.website && !_this.detail.website) {
            _this.detail.website = customer.website;
          }
        })
        .catch((error) => {
          console.error("Individual search error:", error); // Debug log
          _this.logError(error);
        });
    },

    editDetails() {
      const _this = this;

      _this.defaultPerson = _this.getDefaultPerson(_this.customer);
      _this.emailDetails = _this.getEmailDetails(_this.customer);
      _this.contactDetails = _this.getPhoneDetails(_this.customer);

      const faxContactDetails = _this.lodash.filter(_this.contactDetails, {
        title: "fax",
      });

      const mainContactDetails = _this.lodash.filter(_this.contactDetails, {
        title: "main",
      });

      if (_this.lodash.isEmpty(mainContactDetails)) {
        _this.contactDetails.push({
          title: "main",
          value: null,
          type: 2,
          id: null,
        });
      }

      if (_this.lodash.isEmpty(faxContactDetails)) {
        _this.contactDetails.push({
          title: "fax",
          value: null,
          type: 2,
          id: null,
        });
      }
      _this.detail.id = _this.customer.id;
      _this.detail.salutation = _this.defaultPerson.title;
      _this.detail.first_name = _this.defaultPerson.first_name;
      _this.detail.last_name = _this.defaultPerson.last_name;

      _this.detail.primary = _this.customer.primary;

      _this.detail.company_name = _this.customer.company_name;
      _this.detail.company_type = _this.customer.company_type;
      _this.detail.uen = _this.customer.uen;
      _this.detail.display_name = _this.customer.display_name;
      _this.detail.customer_remark = _this.customer.customer_remark;
      _this.detail.entity_id = _this.customer.entity_id;
      _this.detail.group_id = _this.customer.group_id;
      _this.detail.phone = _this.customer.phone;
      _this.detail.website = _this.customer.website;
      _this.detail.unit_no = _this.customer.unit_no;
      _this.detail.address_line_1 = _this.customer.address_line_1;
      _this.detail.address_line_2 = _this.customer.address_line_2;
      _this.detail.category = _this.customer.category;
      _this.detail.category_color = _this.customer.category_color;
      _this.detail.tags = _this.customer.tags;
      _this.detail.company_number = _this.customer.company_number;
      _this.detail.company_fax = _this.customer.company_fax;
      _this.detail.email = _this.customer.company_email;
      _this.detail.company_type = _this.customer.company_type;
      _this.detail.postal_code = _this.customer.postal_code;
      _this.detail.country = _this.customer.country;
      _this.detail.security_code = _this.customer.security_code;
      _this.detail.state = _this.customer.state;
      _this.detail.city = _this.customer.city;
      _this.detail.profile_logo = _this.customer.profile_logo;
      _this.detail.retention_period = _this.customer.retention_period;
      _this.detail.deletion_period = _this.customer.deletion_period;
      _this.detail.period = _this.customer.period;
      _this.detail.automatic_deletion_period =
        _this.customer.automatic_deletion_period;
      //sap detail
      _this.detail.sap_customer_no = _this.customer.sap_customer_no
        ? _this.customer.sap_customer_no
        : null;
      _this.detail.cust_vend_ref_no = _this.customer.cust_vend_ref_no
        ? _this.customer.cust_vend_ref_no
        : null;

      _this.$store.commit(SET_ACTIVE_FIELD_DATA, _this.customer.custom_fields);
      this.$nextTick(() => {
        this.setSelectedCompany();
      });
    },
  },
  mounted() {
    const _this = this;
    _this.getGroupList();
    this.getOptions();
    this.$nextTick(() => {
      this.setSelectedCompany();
      this.companyRouteDialogEnabled = true;
    });
    if (this.detail.company_name) {
      this.selectedCompany = this.detail.company_name;
    }
    if (_this.lodash.isEmpty(_this.lead) && !_this.detail.company_type) {
      _this.detail.company_type = "company";
    }
    // Set default lead type if not set
    if (!_this.detail.lead_type) {
      _this.detail.lead_type = "new";
    }
    // Set default country if not set
    if (!_this.detail.country) {
      _this.detail.country = "singapore";
    }
  },

  created() {
    this.debouncedEmailCheck = this.debounce((value) => {
      if (this.isPrefilling) {
        this.searchIndividualByEmail(value);
        this.isPrefilling = false;
      }
    }, 300);

    this.debouncedCompanySearch = this.debounce((value) => {
      this.searchCompanyByName(value);
    }, 400);
  },

  components: {
    PhoneTextField,
    ManageProductType,
    DatePicker,
    ManagePosition,
    Dialog,
    // DocumnetList,
    CollapsibleDocumnetList,
    SearchAddress,
  },
  computed: {
    isUpdateMode() {
      return !!this.detail.id;
    },
    showCompanyName() {
      return this.detail.company_type === "company";
    },
    companyList() {
      const list = this.options.companies || [];
      console.log("Company list:", list);
      return list;
    },
  },
};
</script>

<style scoped>
.required:after {
  content: " *";
  color: red;
}

.field-label {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
